import React, { useState } from "react";
import { Link } from "react-router-dom";
import Jsondata from "../mensjacket.json";
import { useDispatch } from "react-redux";
import {
  addToCart,
  addToCheckOut,
  addToWishlist,
} from "../../Redux_Store/actions";

const NewArrival = () => {
  const [data, setData] = useState(Jsondata);

  const dispatch = useDispatch();
  const addingItemToCart = (item) => {
    // console.log(id);
    dispatch(addToCart(item));
  };
  return (
    <>
      <div>
        <h1 className="newArrival-heading">New Arrivals</h1>

        <div className="products_container">
          {data.map((item) => {
            return (
              <div
                key={item.id}
                className="flex font-sans border-solid border-2 border-cyan-100 m-2 w-96"
                style={{ width: 340, height: 180 }}
              >
                <div className="flex-none w-28 h-full relative">
                  <img
                    src={item.img}
                    alt=""
                    className="absolute inset-0 w-full h-full object-cover"
                    loading="lazy"
                  />
                </div>
                <form className="flex-auto p-3">
                  <div className="flex flex-wrap">
                    <h1 className="flex-auto text-lg font-semibold text-slate-900">
                      {item.name}
                    </h1>
                    <div className="text-lg font-semibold text-slate-500">
                      {item.price}
                    </div>
                  </div>
                  <div className="flex justify-between mt-2">
                    {/* <p>{`${item.size[0]} ${item.size[1]} ${item.size[2]}`}</p> */}

                    <select
                      id="small"
                      className="block h-8 w-16  text-sm text-gray-900 border border-gray-300 rounded-lg bg-gray-50 focus:ring-blue-500 focus:border-blue-500 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                    >
                      <option selected>Size</option>
                      <option value="S">S</option>
                      <option value="L">L</option>
                      <option value="XL">XL</option>
                      <option value="XXL">XXL</option>
                    </select>
                    <div className="flex space-x-4 mb-6 text-sm font-medium">
                      <button
                        className="flex-none flex items-center justify-center w-7 h-7 rounded-md text-slate-300 border border-slate-200 bg-fuchsia-800"
                        type="button"
                        onClick={() => {
                          dispatch(addToWishlist(item));
                        }}
                        aria-label="Like"
                      >
                        <svg
                          width="20"
                          height="20"
                          fill="currentColor"
                          aria-hidden="true"
                        >
                          <path
                            fillRule="evenodd"
                            clipRule="evenodd"
                            d="M3.172 5.172a4 4 0 015.656 0L10 6.343l1.172-1.171a4 4 0 115.656 5.656L10 17.657l-6.828-6.829a4 4 0 010-5.656z"
                          />
                        </svg>
                      </button>
                    </div>
                  </div>

                  <p className="text-sm text-slate-700">{item.type}</p>
                  <div className="flex-auto flex space-x-4 mt-2">
                    <Link to="/checkout">
                      <button
                        className=" h-8 w-20 font-semibold rounded-md bg-black text-white"
                        type="button"
                        onClick={() => dispatch(addToCheckOut(item))}
                        style={{ fontSize: 11 }}
                      >
                        Buy now
                      </button>
                    </Link>
                    <button
                      className="h-8 w-20 font-semibold rounded-md border border-slate-200 text-slate-900"
                      type="button"
                      onClick={() => addingItemToCart(item)}
                      style={{ fontSize: 11 }}
                    >
                      Add to bag
                    </button>
                  </div>
                </form>
              </div>
            );
          })}
        </div>
      </div>
    </>
  );
};

export default NewArrival;
